
  // document.addEventListener('DOMContentLoaded', function () {

  //   document.querySelectorAll('.interactive-hotspots-section').forEach(function (section) {

  //     const hotspots = section.querySelectorAll('[data-hotspot]');

  //     hotspots.forEach(function (hotspot) {

  //       const dot = hotspot.querySelector('.hotspot-dot');
  //       const close = hotspot.querySelector('.hotspot-close');

  //       if (!dot) return;

  //       dot.addEventListener('click', function (event) {

  //         event.preventDefault();
  //         event.stopPropagation();
  //         if (window.innerWidth >= 750) return;

  //         hotspots.forEach(function (item) {
  //           if (item !== hotspot) {

  //             item.classList.remove('is-active');

  //             const itemDot = item.querySelector('.hotspot-dot');

  //             if (itemDot) {
  //               itemDot.setAttribute('aria-expanded', 'false');
  //             }

  //           }

  //         });

  //         const active = hotspot.classList.toggle('is-active');

  //         dot.setAttribute(
  //           'aria-expanded',
  //           active ? 'true' : 'false'
  //         );

  //       });


  //       if (close) {

  //         close.addEventListener('click', function (event) {

  //           event.preventDefault();
  //           event.stopPropagation();

  //           hotspot.classList.remove('is-active');

  //           dot.setAttribute('aria-expanded', 'false');

  //         });

  //       }

  //     });



  //     document.addEventListener('click', function (event) {

  //       if (window.innerWidth >= 750) return;

  //       if (!section.contains(event.target)) return;

  //       hotspots.forEach(function (hotspot) {

  //         if (!hotspot.contains(event.target)) {

  //           hotspot.classList.remove('is-active');

  //           const dot = hotspot.querySelector('.hotspot-dot');

  //           if (dot) {
  //             dot.setAttribute('aria-expanded', 'false');
  //           }

  //         }

  //       });

  //     });

  //   });

  // });



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.interactive-hotspots-section').forEach(function (section) {
    const hotspots = section.querySelectorAll('[data-hotspot]');

    hotspots.forEach(function (hotspot) {
      const dot = hotspot.querySelector('.hotspot-dot');
      const close = hotspot.querySelector('.hotspot-close');

      if (!dot) return;

      /*
       * ==========================================
       * DESKTOP / TABLET
       * Above 1199px = HOVER
       * ==========================================
       */

      dot.addEventListener('mouseenter', function () {
        if (window.innerWidth <= 1199) return;

        // Close other hotspots
        hotspots.forEach(function (item) {
          if (item !== hotspot) {
            item.classList.remove('is-active');

            const itemDot = item.querySelector('.hotspot-dot');

            if (itemDot) {
              itemDot.setAttribute('aria-expanded', 'false');
            }
          }
        });

        hotspot.classList.add('is-active');
        dot.setAttribute('aria-expanded', 'true');
      });

      /*
       * Keep popup open while mouse is
       * anywhere inside hotspot-item
       */
      hotspot.addEventListener('mouseleave', function () {
        if (window.innerWidth <= 1199) return;

        hotspot.classList.remove('is-active');
        dot.setAttribute('aria-expanded', 'false');
      });


      /*
       * ==========================================
       * MOBILE
       * Below 1199px = CLICK
       * ==========================================
       */

      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (window.innerWidth > 1199) return;

        // Close other hotspots
        hotspots.forEach(function (item) {
          if (item !== hotspot) {
            item.classList.remove('is-active');

            const itemDot = item.querySelector('.hotspot-dot');

            if (itemDot) {
              itemDot.setAttribute('aria-expanded', 'false');
            }
          }
        });

        // Toggle current hotspot
        const active = hotspot.classList.toggle('is-active');

        dot.setAttribute(
          'aria-expanded',
          active ? 'true' : 'false'
        );
      });


      /*
       * ==========================================
       * MOBILE CLOSE BUTTON
       * ==========================================
       */

      if (close) {
        close.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          hotspot.classList.remove('is-active');
          dot.setAttribute('aria-expanded', 'false');
        });
      }
    });


    /*
     * ==========================================
     * MOBILE CLICK OUTSIDE
     * ==========================================
     */

    document.addEventListener('click', function (event) {
      if (window.innerWidth > 1199) return;

      if (!section.contains(event.target)) return;

      hotspots.forEach(function (hotspot) {
        if (!hotspot.contains(event.target)) {
          hotspot.classList.remove('is-active');

          const dot = hotspot.querySelector('.hotspot-dot');

          if (dot) {
            dot.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  });
});